import React from "react";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardMedia from "@material-ui/core/CardMedia";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import {
    makeStyles,
    createMuiTheme,
    ThemeProvider,
} from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import IconButton from "@material-ui/core/IconButton";
import SchoolIcon from "@material-ui/icons/School";
import BookIcon from "@material-ui/icons/Book";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import GitHubIcon from "@material-ui/icons/GitHub";

import drNurfadhlina from "../../img/team/drNurfadhlina.jpg";
import drNorwati from "../../img/team/drNorwati.jpg";
import drRazali from "../../img/team/drRazali.jpg";
import drErzam from "../../img/team/drErzam.jpg";
import drKA from "../../img/team/drKA.jpg";
import drMaslina from "../../img/team/drMaslina.jpg";
import yeokeat from "../../img/team/yeokeat.jpg";
import jason from "../../img/team/jason.jpg";

const teams = [
    {
        name: "Assoc. Prof. Ts. Dr. Nurfadhlina Mohd Sharef",
        image: drNurfadhlina,
        title: "Project Leader",
        profile: "https://sites.google.com/view/nurfadhlina",
    },
    {
        name: "Assoc. Prof. Datin Dr. Norwati Mustapha",
        image: drNorwati,
        title: "Project Member",
        profile: "https://profile.upm.edu.my/norwati/professional.html",
    },
    {
        name: "Assoc. Prof. Dr. Razali Yaakob",
        image: drRazali,
        title: "Project Member",
        profile: "https://profile.upm.edu.my/razaliy/professional.html",
    },
    {
        name: "Assoc. Prof. Dr. Erzam Marlisah",
        image: drErzam,
        title: "Project Member",
        profile: "https://profile.upm.edu.my/erzam/professional.html",
    },
    {
        name: "Assoc. Prof. Dr. Khairul Azhar Kasmiran",
        image: drKA,
        title: "Project Member",
        profile: "https://profile.upm.edu.my/k_azhar/professional.html",
    },
    {
        name: "Assoc. Prof. Dr. Maslina Zolkepli",
        image: drMaslina,
        title: "Project Member",
        profile: "https://profile.upm.edu.my/masz/professional.html",
    },
];

const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        height: "35vh",
        fontFamily: ['"Segoe UI"', "Roboto", "Arial", "sans-serif"].join(","),
    },
    details: {
        display: "flex",
        width: "50%",
        flexDirection: "column",
    },
    content: {
        flex: "1 0 auto",
    },
    cover: {
        width: "50%",
    },
    controls: {
        display: "flex",
        alignItems: "center",
        paddingLeft: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        justifyContent: "flex-end",
        paddingRight: theme.spacing(1),
    },
    playIcon: {
        height: 38,
        width: 38,
    },
}));

const theme = createMuiTheme();
theme.typography.h6 = {
    fontSize: "1.0rem",
    "@media (min-width:600px)": {
        fontSize: "1.2rem",
    },
    [theme.breakpoints.up("md")]: {
        fontSize: "1.2rem",
    },
};

export default function Team() {
    const classes = useStyles();

    return (
        <div>
            <Container className={classes.cardGrid} maxWidth="md">
                <Typography
                    component="h2"
                    variant="h3"
                    align="center"
                    style={{ color: "#000", margin: "5rem 0rem 5rem" }}
                >
                    Core Team Members
                </Typography>
                <ThemeProvider theme={theme}>
                    <Grid container spacing={4}>
                        {teams.map((team, i) => {
                            return (
                                <Grid key={i} item xs={12} sm={6} md={6}>
                                    <Card className={classes.root}>
                                        <CardMedia
                                            className={classes.cover}
                                            image={team.image}
                                            title="VLearnAI"
                                            alignItems="center"
                                        />
                                        <div className={classes.details}>
                                            <CardContent
                                                className={classes.content}
                                            >
                                                <Typography
                                                    component="h6"
                                                    variant="h6"
                                                >
                                                    {team.name}
                                                </Typography>
                                                <Typography
                                                    variant="subtitle1"
                                                    color="textSecondary"
                                                >
                                                    {team.title}
                                                </Typography>
                                                <Typography
                                                    variant="subtitle2"
                                                    color="textSecondary"
                                                >
                                                    <Box m={1}>
                                                        Intelligent Computing
                                                        Research Group
                                                    </Box>
                                                </Typography>
                                                <Typography
                                                    variant="subtitle2"
                                                    color="textSecondary"
                                                >
                                                    Faculty of Computer Science
                                                    and Information Technology
                                                    UPM
                                                </Typography>
                                            </CardContent>
                                            <div className={classes.controls}>
                                                <IconButton
                                                    aria-label="Lecturer"
                                                    href={team.profile}
                                                    target="_blank"
                                                >
                                                    <SchoolIcon />
                                                </IconButton>
                                                <IconButton aria-label="Publish">
                                                    <BookIcon />
                                                </IconButton>
                                            </div>
                                        </div>
                                    </Card>
                                </Grid>
                            );
                        })}

                        <Grid item xs={12} sm={6} md={6}>
                            <Card className={classes.root}>
                                <CardMedia
                                    className={classes.cover}
                                    image={yeokeat}
                                    title="Live from space album cover"
                                />
                                <div className={classes.details}>
                                    <CardContent className={classes.content}>
                                        <Typography component="h6" variant="h6">
                                            Yeo Keat
                                        </Typography>
                                        <Typography
                                            variant="subtitle1"
                                            color="textSecondary"
                                        >
                                            Intelligent System Researcher
                                        </Typography>
                                        <Typography
                                            variant="subtitle2"
                                            color="textSecondary"
                                        >
                                            <Box m={1}>
                                                Intelligent Computing Research
                                                Group
                                            </Box>
                                        </Typography>
                                        <Typography
                                            variant="subtitle2"
                                            color="textSecondary"
                                        >
                                            Faculty of Computer Science and
                                            Information Technology UPM
                                        </Typography>
                                    </CardContent>
                                    <div className={classes.controls}>
                                        <IconButton aria-label="LinkedIn Profile">
                                            <LinkedInIcon />
                                        </IconButton>
                                        <IconButton aria-label="Github Profile">
                                            <GitHubIcon />
                                        </IconButton>
                                    </div>
                                </div>
                            </Card>
                        </Grid>
                        <Grid item xs={12} sm={6} md={6}>
                            <Card className={classes.root}>
                                <CardMedia
                                    className={classes.cover}
                                    image={jason}
                                    title="Live from space album cover"
                                />
                                <div className={classes.details}>
                                    <CardContent className={classes.content}>
                                        <Typography component="h6" variant="h6">
                                            Jason Wong
                                        </Typography>
                                        <Typography
                                            variant="subtitle1"
                                            color="textSecondary"
                                        >
                                            Software Engineer
                                        </Typography>
                                        <Typography
                                            variant="subtitle2"
                                            color="textSecondary"
                                        >
                                            <Box m={1}>
                                                Intelligent Computing Research
                                                Group
                                            </Box>
                                        </Typography>
                                        <Typography
                                            variant="subtitle2"
                                            color="textSecondary"
                                        >
                                            Faculty of Computer Science and
                                            Information Technology UPM
                                        </Typography>
                                    </CardContent>
                                    <div className={classes.controls}>
                                        <a href="https://www.linkedin.com/in/jasonwvh/">
                                            <IconButton aria-label="LinkedIn Profile">
                                                <LinkedInIcon />
                                            </IconButton>
                                        </a>
                                        <a href="https://github.com/jasonwvh">
                                            <IconButton aria-label="Github Profile">
                                                <GitHubIcon />
                                            </IconButton>
                                        </a>
                                    </div>
                                </div>
                            </Card>
                        </Grid>
                    </Grid>
                </ThemeProvider>
            </Container>
        </div>
    );
}
